import { z } from 'zod';
export function paginationQuerySchema<T extends z.ZodTypeAny>(orderFields: T) {
  return z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(2000).default(20),
    orderBy: orderFields.optional(),
    orderDirection: z.enum(['asc', 'desc']).default('asc')
  });
}
export function paginatedSchema<T extends z.ZodTypeAny>(itemSchema: T) {
  return z.object({
    items: z.array(itemSchema),
    length: z.number(),
    count: z.number(),
    page: z.number(),
    maxPage: z.number()
  });
}